import { fetchMfhBuilding } from '@/api/mfh';
import type { MFHBuildingExpandOpts } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';
import type { MaybeRef } from 'vue';
import { computed, unref } from 'vue';

export const useMfhBuilding = (mfhBuildingId: MaybeRef<number | undefined>, expandOpts: MaybeRef<MFHBuildingExpandOpts>) => {
    const queryKey = computed(() => ['mfh-building', mfhBuildingId, expandOpts]);
    const enabled = computed(() => !!unref(mfhBuildingId));

    return useQuery(queryKey, async () => fetchMfhBuilding(unref(mfhBuildingId), unref(expandOpts)), {
        initialData: null,
        enabled,
    });
};
